import { Tag } from "@/ui";
import { EyeOff } from "lucide-react";

export default function HiddenChip() {
  return (
    <Tag
      variant="minimalOutline"
      size="sm"
      icon={<EyeOff size={14} aria-hidden="true" />}
      style={{ width: "fit-content", alignSelf: "flex-start" }}
    >
      This is hidden. Click to show.
    </Tag>
  );
}
